import React, { useContext } from 'react';
import { ChatReferenceDto } from '../../apis/nhe-ai-chat-service/nhe-ai-chat-service.dtos';
import { AppContext } from '../app/AppProvider.component';
import { getOsmosisVideoId } from '../../pages/ai-chat/ai-chat.utilities';
import { osmosisVideoUrl } from '../../pages/ai-chat/ai-chat.constants';

export type ReferenceVideoPanelProps = {
  chatReference: ChatReferenceDto;
};

const ReferenceVideoPanel = (props: ReferenceVideoPanelProps): JSX.Element => {
  const { appState } = useContext(AppContext);
  const id = getOsmosisVideoId(props.chatReference);

  return (
    <div>
      <div className="u-els-margin-bottom-1o2">
        {props.chatReference.title}
      </div>
      <iframe
        title="osmosis-video-iframe"
        src={`${osmosisVideoUrl}/embed/${encodeURIComponent(id)}?auth=${appState.osmosisTokenDto.authToken}`}
        className="c-els-ai-chat__osmosis-iframe"
        allowFullScreen
      />
    </div>
  );
};

export default ReferenceVideoPanel;
